// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"291":"7c6999eb","392":"cd3460b2","488":"535652aa","892":"5c5a11cc","952":"c730f37f"}[chunkId] + ".chunk.js";
};